import React, { useEffect, useState } from 'react';

import { AiOutlineClockCircle } from 'react-icons/ai';

import Text from 'v3/components/Text';
import Loader from 'v3/components/Loader';
import Link from 'v3/components/Link';
import Tooltip from 'v3/components/Tooltip';

import { useSnackbar } from 'v3/components/Snackbar';

import api from 'services/api';
import { verifyMostAcessedPermissions } from '../MostAccessed/validator';

import * as Styled from '../Favorites/styles';

function Recents() {
  const snackbar = useSnackbar();

  const [recents, setRecents] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCurrentUserDisplayNames = () => {
    try {
      const user = JSON.parse(localStorage.getItem('usuario')) || {};

      return [user?.name, user?.username, user?.email]
        .filter(Boolean)
        .map((value) => value.toString().trim().toLowerCase());
    } catch {
      return [];
    }
  };

  const isUserIdentityInstance = (instanceValue) => {
    if (!instanceValue) return false;

    const normalizedInstance = instanceValue.toString().trim().toLowerCase();
    return getCurrentUserDisplayNames().includes(normalizedInstance);
  };

  async function getRecents() {
    setLoading(true);
    try {
      const reponse = await api.get('v3/user/logs');
      validateRecentPermission(reponse.data);
    } catch (err) {
      snackbar.show(<Text>Erro ao buscar favoritos disponíveis</Text>, {
        type: 'error',
      });
      return null;
    } finally {
      setLoading(false);
    }
  }

  const validateRecentPermission = (recent) => {
    const validRecentRoutes = verifyMostAcessedPermissions(recent);
    setRecents(validRecentRoutes);
  };

  useEffect(() => {
    getRecents();
  }, []);

  return (
    <>
      <Styled.SectionHeader>
        <Styled.SectionTitleWrap>
          <Styled.SectionIcon>
            <AiOutlineClockCircle size={18} />
          </Styled.SectionIcon>
          <Text color="primary" weight="700" fontSize="36px">
            Recentes
          </Text>
        </Styled.SectionTitleWrap>
      </Styled.SectionHeader>

      {!loading ? (
        <Styled.CardsGrid>
          {recents.length === 0 && (
            <Styled.RecentsWrapper>
              <Styled.Title color="dark" weight="700">
                Ainda não há recentes!
              </Styled.Title>
            </Styled.RecentsWrapper>
          )}

          {recents.map((rec, index) => {
            const showInstance = rec?.instance && !isUserIdentityInstance(rec?.instance);

            return (
              <Link
                withoutIcon
                to={`${rec.path}`}
                target="_blank"
                key={`${rec.path}-${index}`}
              >
                {showInstance ? (
                  <Tooltip content={<Text type="body">{rec?.instance}</Text>} placement="top">
                    <Styled.Wrapper>
                      <Styled.Title color="dark" weight="700" truncate>
                        {rec.name} {rec?.instance && ` -  ${rec?.instance}`}
                      </Styled.Title>
                      <Text type="label">{rec.path}</Text>
                    </Styled.Wrapper>
                  </Tooltip>
                ) : (
                  <Styled.Wrapper>
                    <Styled.Title color="dark" weight="700" truncate>
                      {rec.name}
                    </Styled.Title>
                    <Text type="label">{rec.path}</Text>
                  </Styled.Wrapper>
                )}
              </Link>
            );
          })}
        </Styled.CardsGrid>
      ) : (
        <div className="d-flex justify-content-center mt-5">
          <Loader size="md" loading={loading} />
        </div>
      )}
    </>
  );
}

export default Recents;
